<template>
  <div class="price">
    <mu-dialog
      :title="`查看价格 - ${form.realName}`"
      width="1200"
      :open="open"
      @close="close"
      class="price-dialog"
    >
      <div class="table" @mouseleave="mouseLeave">
        <div class="thickness column">
          <div class="table-item header">厚度</div>
          <div
            :class="['table-item', { active: currentThicknessIndex === index }]"
            v-for="(item, index) in thicknessList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div
          class="price-list column"
          v-for="(material, materialIndex) in price"
          :key="materialIndex"
        >
          <div class="table-item header">
            <div class="material-name">
              {{ material.material }}
            </div>
            <div class="price-category">
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      materialIndex === currentMaterialIndex &&
                      currentPriceCategoryIndex === 0
                  }
                ]"
              >
                切割
              </div>
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      materialIndex === currentMaterialIndex &&
                      currentPriceCategoryIndex === 1
                  }
                ]"
              >
                穿孔
              </div>
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      materialIndex === currentMaterialIndex &&
                      currentPriceCategoryIndex === 2
                  }
                ]"
              >
                材料
              </div>
            </div>
          </div>
          <div
            class="table-item"
            v-for="(thickness, thicknessIndex) in thicknessList"
            :key="thicknessIndex"
          >
            <div
              class="price-category"
              v-if="material.price.find((x) => x.thickness === thickness)"
            >
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      currentMaterialIndex === materialIndex &&
                      currentThicknessIndex === thicknessIndex &&
                      currentPriceCategoryIndex === 0,
                    horActive:
                      (currentThicknessIndex === thicknessIndex &&
                        materialIndex < currentMaterialIndex) ||
                      (currentThicknessIndex === thicknessIndex &&
                        materialIndex === currentMaterialIndex &&
                        currentPriceCategoryIndex > 0),
                    verActive:
                      currentMaterialIndex === materialIndex &&
                      currentPriceCategoryIndex === 0 &&
                      currentThicknessIndex > thicknessIndex
                  }
                ]"
                @mouseenter="current(materialIndex, thicknessIndex, 0)"
              >
                <span
                  v-if="
                    currentMaterialIndex === materialIndex &&
                    currentThicknessIndex === thicknessIndex &&
                    currentPriceCategoryIndex === 0
                  "
                >
                  <input
                    type="text"
                    v-model="
                      material.price.find((x) => x.thickness === thickness)
                        .laserPrice
                    "
                    v-focus
                  />
                </span>
                <span v-else>
                  {{
                    material.price.find((x) => x.thickness === thickness)
                      .laserPrice
                  }}
                </span>
              </div>
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      currentMaterialIndex === materialIndex &&
                      currentThicknessIndex === thicknessIndex &&
                      currentPriceCategoryIndex === 1,
                    horActive:
                      (currentThicknessIndex === thicknessIndex &&
                        materialIndex < currentMaterialIndex) ||
                      (currentThicknessIndex === thicknessIndex &&
                        materialIndex === currentMaterialIndex &&
                        currentPriceCategoryIndex > 1),
                    verActive:
                      currentMaterialIndex === materialIndex &&
                      currentPriceCategoryIndex === 1 &&
                      currentThicknessIndex > thicknessIndex
                  }
                ]"
                @mouseenter="current(materialIndex, thicknessIndex, 1)"
              >
                <span
                  v-if="
                    currentMaterialIndex === materialIndex &&
                    currentThicknessIndex === thicknessIndex &&
                    currentPriceCategoryIndex === 1
                  "
                >
                  <input
                    type="text"
                    v-model="
                      material.price.find((x) => x.thickness === thickness)
                        .kongPrice
                    "
                    v-focus
                  />
                </span>
                <span v-else>
                  {{
                    material.price.find((x) => x.thickness === thickness)
                      .kongPrice
                  }}
                </span>
              </div>
              <div
                :class="[
                  'price-item',
                  {
                    active:
                      currentMaterialIndex === materialIndex &&
                      currentThicknessIndex === thicknessIndex &&
                      currentPriceCategoryIndex === 2,
                    horActive:
                      currentThicknessIndex === thicknessIndex &&
                      materialIndex < currentMaterialIndex,
                    verActive:
                      currentMaterialIndex === materialIndex &&
                      currentPriceCategoryIndex === 2 &&
                      currentThicknessIndex > thicknessIndex
                  }
                ]"
                @mouseenter="current(materialIndex, thicknessIndex, 2)"
              >
                <span
                  v-if="
                    currentMaterialIndex === materialIndex &&
                    currentThicknessIndex === thicknessIndex &&
                    currentPriceCategoryIndex === 2
                  "
                >
                  <input
                    type="text"
                    v-model="
                      material.price.find((x) => x.thickness === thickness)
                        .materialPrice
                    "
                    v-focus
                  />
                </span>
                <span v-else>
                  {{
                    material.price.find((x) => x.thickness === thickness)
                      .materialPrice
                  }}
                </span>
              </div>
            </div>
            <div class="price-item" v-else>/</div>
          </div>
        </div>
      </div>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit"
        >保存价格</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      price: [],
      roleList: [],
      thicknessList: [
        1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 18, 20, 22, 25, 30, 35
      ],
      currentMaterialIndex: -1,
      currentPriceCategoryIndex: -1,
      currentThicknessIndex: -1
    }
  },
  methods: {
    submit() {
      backend(api.user.update, { ...this.form, price: this.price }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.$toast.success('保存成功')
            this.close()
            this.$emit('finish')
          }
        }
      )
    },
    close() {
      this.$emit('update:open', false)
    },
    current(materialIndex, thicknessIndex, priceCategoryIndex) {
      this.currentMaterialIndex = materialIndex
      this.currentThicknessIndex = thicknessIndex
      this.currentPriceCategoryIndex = priceCategoryIndex
    },
    mouseLeave() {
      this.currentMaterialIndex = -1
      this.currentThicknessIndex = -1
      this.currentPriceCategoryIndex = -1
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.price = JSON.parse(JSON.stringify(this.form.price))
      }
    }
  },
  mounted() {
    // this.getAllRole()
  }
}
</script>

<style lang="less" scoped>
.price-dialog {
  .table {
    display: flex;
    justify-content: space-between;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    .column {
      flex: 1;
      &.thickness {
        flex: 0 0 80px;
      }
      .table-item {
        border-left: 1px solid #ddd;
        border-top: 1px solid #ddd;
        text-align: center;
        line-height: 40px;
        &.active {
          background: #00a2ff;
          color: #fff;
        }
        &.header {
          height: 80px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .price-category {
          display: flex;
          justify-content: center;
          .price-item {
            flex: 1;
            &.active {
              background: #00a2ff;
              color: #fff;
            }
            &.horActive,
            &.verActive {
              background: #ddd;
            }
            input {
              height: 100%;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customer/price.vue